<template>
  <svg
    class="fill-current w-5"
    viewBox="0 0 16 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25905 5.32784H6.26105H6.26277C6.68836 5.31491 6.98552 4.99425 6.98552 4.548C6.98552 4.09011 6.67993 3.75781 6.25919 3.75781C5.85031 3.75781 5.54187 4.09302 5.54187 4.53766C5.54173 4.99538 5.84346 5.32784 6.25905 5.32784Z"
    />
    <path
      d="M9.52883 5.32784H9.53083H9.53283C9.95828 5.31491 10.2551 4.99425 10.2551 4.548C10.2551 4.09011 9.94985 3.75781 9.52897 3.75781C9.12023 3.75781 8.81165 4.09302 8.81165 4.53766C8.8115 4.99538 9.11323 5.32784 9.52883 5.32784Z"
    />
    <path
      d="M12.0825 5.51582C11.9025 5.32785 11.5961 5.34175 11.4298 5.5454C10.478 6.71411 9.10794 7.35803 7.70244 7.29386C6.42123 7.23552 5.23688 6.61568 4.36712 5.54847C4.20111 5.34515 3.89481 5.33076 3.71466 5.51873C3.52751 5.71414 3.51565 6.04547 3.68823 6.25687C4.72457 7.52871 6.13707 8.26782 7.66487 8.33829C7.7423 8.34184 7.81902 8.34346 7.89588 8.34346C7.97874 8.34346 8.06117 8.34136 8.14389 8.33764C9.66611 8.2641 11.0739 7.52386 12.1088 6.25364C12.1922 6.15101 12.2358 6.01783 12.2308 5.87835C12.2257 5.73886 12.1725 5.61005 12.0825 5.51582Z"
    />
    <path
      d="M13.5571 10.4355H12.0381L10.3595 12.3344L8.76104 10.4355H2.23955V1.66539H13.5571V10.4355ZM2.23955 0C1.42637 0 0.767334 0.74574 0.767334 1.66555V10.4355C0.767334 11.3552 1.42637 12.1012 2.23955 12.1012H8.12986L9.29349 13.4834C9.56679 13.8086 9.9451 13.9945 10.3414 14C10.3474 14 10.3535 14 10.3595 14C10.7496 14 11.1242 13.8248 11.4002 13.5124L12.6478 12.1012H13.5569C14.3696 12.1012 15.0291 11.3553 15.0291 10.4355L15.0294 1.66555C15.0294 0.74574 14.3705 0 13.5571 0H2.23955Z"
    />
  </svg>
</template>
